import { Grid, Chip, Tooltip, Box } from "@mui/material";
import React from "react";
import classes from "./ReadOnlyField.module.css";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";

const MAX_VISIBLE_TAGS = 3;

//Default length will be conisdered as 6.
const validateLength = (length) => (length > 0 ? length : 6);
// Bug fix: was `text || ""`, which silently dropped a legitimate 0 (falsy)
// value — e.g. a count field genuinely equal to 0 rendered as blank.
const validateText = (text) => (text ?? "").toString();
const isTags = (text) => String(text).includes(",");

export const StyledChip = styled(Chip)(() => ({
  borderRadius: "32px",
  maxWidth: 120,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  "& .MuiChip-label": {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    display: "block",
    maxWidth: "100%",
  },
}));

export const LimitChip = styled(Chip)(() => ({
  fontWeight: "bold",
  color: "#3299FF",
}));

export default function ReadOnlyField(props) {
  const labelLength = validateLength(props?.labelLength);
  const fieldLength = validateLength(props?.fieldLength);
  const labelText = validateText(props?.labelText);
  const fieldText = validateText(props?.fieldText);

  const tags = fieldText
    ? String(fieldText)
        .split(",")
        .map((t) => t.trim())
        .filter(Boolean)
    : [];

  const visibleTags = tags.slice(0, MAX_VISIBLE_TAGS);
  const hiddenTags = tags.slice(MAX_VISIBLE_TAGS);

  return (
    <Grid container>
      <Grid item xs={labelLength} className={classes.labelText}>
        {`${labelText} :`}
      </Grid>
      <Grid item xs={fieldLength} className={classes.fieldText}>
        {tags.length > 3 ? (
          <Box style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
            {visibleTags.map((tag, i) => (
              <StyledChip key={i} label={tag} size="small" />
            ))}
            {hiddenTags.length > 0 && (
              <Tooltip title={hiddenTags.join(", ")} arrow placement="top">
                {/* Bug fix: MUI's Chip doesn't support children — only `label`.
                    Passing both triggered a propTypes warning; label alone
                    already renders the "+N" text. */}
                <LimitChip label={`+${hiddenTags.length}`} />
              </Tooltip>
            )}
          </Box>
        ) : (
          <Tooltip title={fieldText} arrow>
            <span>{fieldText}</span>
          </Tooltip>
        )}
      </Grid>
    </Grid>
  );
}

ReadOnlyField.propTypes = {
  labelLength: PropTypes.number,
  fieldLength: PropTypes.number,
  labelText: PropTypes.string,
  // Bug fix: several callers (e.g. DTR count/readiness fields) legitimately pass
  // numeric values (counts, IDs) through fieldText — this was string-only.
  fieldText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
